module.exports = __webpack_public_path__ + "img/map-large-2.473af61e.jpg";